import confirm from '../../../utils/confirm.jsx';
import { money } from '../../../utils/format';

export function request(id, { amount, method, type, trader, displayedReason }, usePaymentFormForUniverse) { 
    const moneyForView = money(amount);

    const action = method === 'withdraw' ? 'withdraw' : 'deposit';

    return confirm('Are you sure that you want to ' + action + ' ' + moneyForView + '?', {
        type: 'CUSTOMERS_ADJUST_REQUEST',
        paymentType: type,
        displayedReason,
        method,
        trader,
        amount,
        id
    });
}

export function error(id, errors) {
    return {
        type: 'CUSTOMERS_ADJUST_ERROR',
        errors,
        id
    };
}

export function finish(id, { customer, transaction }) {
    return {
        type: 'CUSTOMERS_ADJUST_FINISH',
        transaction,
        customer,
        id
    };
}

export function clear(id) {
    return {
        type: 'CUSTOMERS_ADJUST_CLEAR',
        id
    };
}
